import type { ShipmentState } from '../api/types';

/**
 * What a shipment's state reads as on screen. Only the label changes: the
 * stored state stays `DISPATCHED` (it is what the API, the audit log and the
 * order saga all key on) — the business calls that stage "out for delivery".
 */
export const shipmentStateLabel = (state: ShipmentState): string =>
  state === 'DISPATCHED' ? 'OUT FOR DELIVERY' : state.replace(/_/g, ' ');
